import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KM_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#KM_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#5196ED"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KM_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#KM_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 12v6h32v-6H0z", fill: "#AF0100" }), /* @__PURE__ */ e.createElement("path", { d: "M0 6v6h32V6H0z", fill: "#F7FCFF" }), /* @__PURE__ */ e.createElement("path", { d: "M0 0v6h32V0H0z", fill: "#FECA00" }), /* @__PURE__ */ e.createElement("path", { d: "M0 0l19 12L0 24V0z", fill: "#5EAA22" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.304 16.501s-3.583-1.223-3.456-5.052C3.974 7.622 7.623 6.87 7.623 6.87c-1.278-.922-5.85.159-5.996 4.58-.147 4.42 4.315 5.402 5.677 5.051zm.108-6.692l.112-.654-.475-.464.657-.096L8 8l.294.595.657.096-.475.464.112.654L8 9.5l-.588.309zm.112 1.346l-.112.654L8 11.5l.588.309-.112-.654.475-.464-.657-.096L8 10l-.294.595-.657.096.475.463zm-.112 2.654l.112-.654-.475-.464.657-.096L8 12l.294.595.657.096-.475.463.112.655L8 13.5l-.588.309zm0 2l.112-.654-.475-.464.657-.096L8 14l.294.595.657.096-.475.463.112.655L8 15.5l-.588.309z",
      fill: "#F7FCFF"
    }
  )))
), a = t;
export {
  a as default
};
